module.exports = "li {\n  list-style: none;\n  line-height: 20px; }\n\np {\n  line-height: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/alg-socio-modal/alg-socio-modal.component.scss
// module id = ./src/app/components/dialogs/alg-socio-modal/alg-socio-modal.component.scss
// module chunks = main